import React from 'react';
import SessionStorageService from 'ui-common/src/utils/SessionStorageService';
import { useSelector } from 'react-redux';
import MenuList from '../MenuList/MenuList';
import findAssociatedMenuForNavigatedUrl from '../../utils/findAssociatedMenuForNavigatedUrl';
import { removeMenuById } from '../../utils/removeMenuByID/removeMenuByID';
import filterUnifiedNavSubmenuView from './utils';

const ChildMenu = ({
  data: sourceData,
  selected,
  handleBackClick,
  topLevelMenuOpen,
  expandSideMenu,
  collapseSideMenu,
  selectedMenuId,
  isSearchActive,
}) => {
  const {
    PAM_EMERGENCY_ROLE_NAV_ENABLED: isEmergencyRolesUser,
    ISPM_SERVICES_ENABLED: isISPMEnabled,
  } = useSelector((state) => state.user.domainInfo || {});
  const pamGen2Flag = window.localStorage.getItem('pamGen2');
  const isPamGen2 = parseInt(pamGen2Flag);
  const data = isISPMEnabled ? sourceData : removeMenuById(sourceData, 'ispm');

  // customer feature flags
  const featureFlags = {
    isPamGen2,
    isEmergencyRolesUser,
  };

  if (!topLevelMenuOpen) {
    return (
      <MenuList
        data={data}
        handleBackClick={handleBackClick}
        isParentOpen={topLevelMenuOpen}
        expandSideMenu={expandSideMenu}
        selected={selected}
        selectedMenuId={selectedMenuId}
        collapseSideMenu={collapseSideMenu}
        isSearchActive={isSearchActive}
      />
    );
  }
  let menu = findAssociatedMenuForNavigatedUrl(data, selected);
  if (!menu) {
    menu = JSON.parse(localStorage.getItem('currentMenu'));
    SessionStorageService.set('currentMenu', localStorage.getItem('currentMenu'));
  }

  let filteredData;
  const stillBrowsingThruMenu = () => selectedMenuId !== '';
  const filterForSelectedMenu = () => data.filter((f) => f.id === selectedMenuId);
  const isNavigatedUrlAssociatedWithMenu = () =>
    menu !== 'null' && menu !== null && menu?.parentID?.length !== 0;
  const filterForAllParentMenus = () => data.filter((f) => menu?.parentID?.includes(f.id));

  if (isSearchActive) {
    filteredData = data;
  } else if (stillBrowsingThruMenu()) {
    filteredData = filterForSelectedMenu();
  } else if (isNavigatedUrlAssociatedWithMenu()) {
    filteredData = filterForAllParentMenus();
  } else {
    handleBackClick(selectedMenuId);
    filteredData = data;
  }

  switch (filteredData[0]?.id) {
    case 'home':
      filteredData[0].subMenu.forEach((item) => {
        /* Show/Hide the menus based on feature flags */
        // TODO: UI-1120 use removeMenuByIds util to filter featureFlags for PAM related menu items
        filterUnifiedNavSubmenuView(item, featureFlags);
      });
      break;
    default:
      break;
  }

  return (
    <MenuList
      data={filteredData}
      selected={selected}
      handleBackClick={handleBackClick}
      isParentOpen={topLevelMenuOpen}
      expandSideMenu={expandSideMenu}
      collapseSideMenu={collapseSideMenu}
      selectedMenuId={selectedMenuId}
      isSearchActive={isSearchActive}
    />
  );
};

export default ChildMenu;
